import markApplyRecords from "./markApplyRecords";

const markApplyRecordService = [{
    matcher: 'processingMarkApplyRecords',
    reply: config => {
        return [200, markApplyRecords]
    }
},{
    matcher: /processingMarkApplyRecords\/(.*)/,
    reply: config => {
        const id = /processingMarkApplyRecords\/(.*)/.exec(config.url)[1];
        const data = markApplyRecords.find(app => app.id === id);
        return [200, data]
    }
}]

export default markApplyRecordService